import React from 'react';
import {useUpdateCollectedFormUrlMutation, CollectedFormUrl} from 'api';
import useDebounce from 'hooks/useDebounce';

interface Props {
  collectedFormUrl: CollectedFormUrl;
}

export default ({collectedFormUrl}: Props) => {
  const [updateCollectedFormUrl] = useUpdateCollectedFormUrlMutation();

  const [value, setValue] = React.useState(
    collectedFormUrl.autoreplyMailSubject,
  );
  const debouncedValue = useDebounce<string>(value, 500);

  React.useEffect(() => {
    debouncedValue !== collectedFormUrl.autoreplyMailSubject &&
      updateCollectedFormUrl({
        variables: {
          collectedFormUrlUuid: collectedFormUrl.uuid,
          attributes: {
            autoreplyMailSubject: debouncedValue,
          },
        },
      });
  }, [collectedFormUrl, debouncedValue]);

  return (
    <div className="flex flex-col gap-12">
      <div className="flex flex-col gap-1 w-full">
        <label className="text-c-base font-bold">件名</label>
        <div className="flex items-center">
          <input
            className="form-input border-c-border rounded text-base w-full disabled:bg-c-bg disabled:text-c-light"
            value={value}
            onChange={(e) => setValue(e.target.value)}
          />
        </div>
        {collectedFormUrl.sendAutoreplyMail && !value ? (
          <div className="text-red-500">
            自動返信メールを送信する場合は件名を入力してください
          </div>
        ) : null}
      </div>
    </div>
  );
};
